// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-table';
const tableMaxHeigh = '25rem';
const dataTdAttr = 'data-table-head';
const tableWrapper = '.wp-block-table';
const tableBreakpoint = '779px';


// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class tableMobile {
  constructor(el) {
    this.el = el;
    this.$table = $(el).find('table');
    this.$tbody = $(el).find('tbody');
    this.$tableHead = $(el).find('thead');
    this.$tableHeadTh = $(el).find('thead th');
    this.$tbodyTr = $(el).find('tbody tr');
    this.$tbodyTd = $(el).find('tbody tr td');
    this.$button = $(el).find('button');
    this.$blockTable = $(el).find(tableWrapper);

    this.mediaMatcher = window.matchMedia(`(max-width: ${tableBreakpoint})`);

    this.fillTbodyAttr();
    if(this.mediaMatcher.matches){
      this.showButton();
    }


    if (this.$button.length === 0) return;

    $(this.$button).on('click', (item) => {
      if (item.target.classList.contains('is-open')) {
        item.target.classList.remove('is-open');
        this.$table[0].parentNode.style.maxHeight = tableMaxHeigh;
        this.$button[0].innerText = 'Alle anzeigen';
      } else {
        const tableHeight = this.$table.outerHeight(true);
        item.target.classList.add('is-open');
        this.$table[0].parentNode.style.maxHeight = `${tableHeight}px`;
        this.$button[0].innerText = 'Weniger anzeigen';
      }
    });

    this.mediaMatcher.addEventListener('change', (event) => {
      if (event.matches) {
        this.showButton(1);
      } else {
        this.$table[0].parentNode.style.maxHeight = '';
        this.showButton(0);
      }
    });
  }

  fillTbodyAttr() {
    if (this.$tableHead.length === 0) return;

    for (const itemTr of this.$tbodyTr) {
      let index = 1;

      for (const itemTd of itemTr.querySelectorAll('td')) {
        const getHeadText = this.$tableHead.find(`th:nth-child(${index})`).text();
        itemTd.setAttribute(dataTdAttr, getHeadText);
        index++
      }
    }
  }

  showButton(status) {
    if (status == 0) {
      this.$button.removeClass('show-more-table--visible');
    } else {
      const tableHeight = this.$tbody.height();

      if (tableHeight >= 400) { //400 entspricht 25rem
        this.$button.addClass('show-more-table--visible');
      } else {
        this.$button.removeClass('show-more-table--visible');
      }
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new tableMobile(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};